
import { Card } from "@/components/ui/card";
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, Legend, BarChart, Bar } from "recharts";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { useOwnerCurrency } from "@/hooks/useOwnerCurrency";

interface StatisticsChartsProps {
  validatedTotal: number;
  lastMonthStats: number;
  yearlyTotal: number;
  customPeriodTotal: number;
  startDate: string;
  endDate: string;
}

export const StatisticsCharts = ({
  validatedTotal = 0,
  lastMonthStats = 0,
  yearlyTotal = 0,
  customPeriodTotal = 0,
  startDate,
  endDate,
}: StatisticsChartsProps) => {
  const { data: currency } = useOwnerCurrency();

  const formatCurrency = (value: number) => {
    return `${value.toLocaleString()} ${currency || 'GNF'}`;
  };

  const data = [
    {
      name: "Ce mois",
      montant: validatedTotal || 0
    },
    {
      name: format(new Date().setMonth(new Date().getMonth() - 1), 'MMMM yyyy', { locale: fr }),
      montant: lastMonthStats || 0
    },
    {
      name: "Cette année",
      montant: yearlyTotal || 0
    },
    ...(startDate && endDate ? [{
      name: `Période ${format(new Date(startDate), 'dd/MM/yyyy')} - ${format(new Date(endDate), 'dd/MM/yyyy')}`,
      montant: customPeriodTotal || 0
    }] : [])
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
      <Card className="p-4">
        <h3 className="text-lg font-medium mb-4">Évolution du chiffre d'affaires</h3>
        <div className="h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data}>
              <XAxis dataKey="name" />
              <YAxis tickFormatter={(value) => `${value.toLocaleString()} ${currency || 'GNF'}`} />
              <Tooltip formatter={(value: any) => formatCurrency(value)} />
              <Legend />
              <Line
                type="monotone"
                dataKey="montant"
                stroke="#10b981"
                name="Chiffre d'affaires"
                strokeWidth={2}
                dot={{ r: 4 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </Card>

      <Card className="p-4">
        <h3 className="text-lg font-medium mb-4">Comparaison des chiffres d'affaires</h3>
        <div className="h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data}>
              <XAxis dataKey="name" />
              <YAxis tickFormatter={(value) => `${value.toLocaleString()} ${currency || 'GNF'}`} />
              <Tooltip formatter={(value: any) => formatCurrency(value)} />
              <Legend />
              <Bar
                dataKey="montant"
                fill="#10b981"
                name="Chiffre d'affaires"
                radius={[4, 4, 0, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </Card>
    </div>
  );
};
